require('slick-carousel/slick/slick');

/*
 |--------------------------------------------------------------------------
 | Document Ready Function
 |--------------------------------------------------------------------------
 */

$(function () {
    'use strict';

    /**
     * Carousel slick
     * @link http://kenwheeler.github.io/slick
     */

    // Carousel from home-logged
    $('.carousel-home').slick({
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    arrows: false,
                    autoplay: true,
                },
            },
        ],
    });

    // Carousel from home-logged
    $('.slider-categories').slick({
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        arrows: false,
        centerMode: true,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    autoplay: true,
                    slidesToShow: 4,
                },
            },
            {
                breakpoint: 780,
                settings: {
                    autoplay: true,
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 640,
                settings: {
                    autoplay: true,
                    slidesToShow: 2,
                },
            },
        ],
    });

    // Carousel from welcome modal and Register page
    $('.slider-welcome-modal, .slider-register').slick({
        autoplay: false,
        autoplaySpeed: 5000,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        centerMode: false,
    });

    // Carousel from registration confirmation - benefits
    $('.slider-benefits').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        centerMode: false,
        autoplay: false,
        infinite: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    autoplay: true,
                    autoplaySpeed: 5000,
                },
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    centerMode: false,
                    autoplay: true,
                    autoplaySpeed: 5000,
                },
            },
        ],
    });

    // Carousel from welcome modal and Register page
    $('.slider-urbanomed-services').slick({
        autoplay: true,
        autoplaySpeed: 5000,
        slidesToShow: 5,
        slidesToScroll: 1,
        arrows: false,
        centerMode: true,
        variableWidth: true,
    });

    // Carousel from welcome modal and Register page
    $('.slider-urbanomed-partners').slick({
        autoplay: true,
        autoplaySpeed: 4000,
        slidesToShow: 5,
        slidesToScroll: 1,
        arrows: false,
        centerMode: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 475,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    });
});
